import { sha256 } from "@noble/hashes/sha2.js";

function bytesToHex(bytes) {
  let out = "";
  for (const byte of bytes) {
    out += Number(byte).toString(16).padStart(2, "0");
  }
  return out;
}

/**
 * Returns the SHA-256 digest of a UTF-8 string as lowercase hexadecimal.
 * Keeping this adapter separate lets unit tests replace the hash boundary
 * without loading the ESM-only Noble implementation inside Jest.
 */
export function sha256Hex(value) {
  const input = new TextEncoder().encode(String(value ?? ""));
  return bytesToHex(sha256(input));
}
